import "./MDLArticle.scss";
import { ReactNode } from "react";

type ArticleElement = {
  type: "text" | "header" | "subheader" | "image";
  content: string;
};

interface MDLArticleProps {
  id: string;
  elements: ArticleElement[];
}

function MDLArticle({ id, elements }: MDLArticleProps) {
  const renderElement = (element: ArticleElement, index: number): ReactNode => {
    switch (element.type) {
      case "header":
        return (
          <h3 key={`${id}-header-${index}`} className="mdl-article-header">
            {element.content}
          </h3>
        );
      case "subheader":
        return (
          <h4 key={`${id}-subheader-${index}`} className="mdl-article-subheader">
            {element.content}
          </h4>
        );
      case "text":
        return (
          <p key={`${id}-text-${index}`} className="mdl-article-text">
            {element.content}
          </p>
        );
      case "image":
        return (
          <div key={`${id}-image-${index}`} className="mdl-article-image-container">
            <img src={element.content} alt="" className="mdl-article-image" />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <article id={id} className="mdl-article">
      {elements.map((element, index) => renderElement(element, index))}
    </article>
  );
}

export default MDLArticle;
